import { useState } from "react";
import type { PastTeamSummary } from "@/api/registrations";
import type { TeamChoice } from "./types";
import { hasNonLatin } from "@/lib/latinName";

/** Initial state helper: pick first past team if any, otherwise empty new-team. */
function initialTeamChoice(pastTeams: PastTeamSummary[]): TeamChoice {
  return pastTeams.length > 0
    ? { kind: "existing", teamId: pastTeams[0].team_id }
    : { kind: "new", name: "" };
}

/** Hook: TeamChoice state + a derived `canSubmit` flag (>= 2 chars for new). */
export function useTeamChoice(pastTeams: PastTeamSummary[]) {
  const [choice, setChoice] = useState<TeamChoice>(() => initialTeamChoice(pastTeams));
  const canSubmit =
    (choice.kind === "existing" && pastTeams.length > 0) ||
    (choice.kind === "new" &&
      choice.name.trim().length >= 2 &&
      !hasNonLatin(choice.name));
  return { choice, setChoice, canSubmit };
}
